import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import Box from "../../../../node_modules/@mui/material/Box/Box.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
const SnackBarContainer = styled(Box, styledOptions)(({
  theme,
  variant
}) => {
  const variantColor = theme.palette[variant ?? "primary"];
  const backgroundColor = variantColor.main;
  const elementsColor = variantColor.contrastText;
  return {
    maxWidth: "fit-content",
    display: Displaying.flex,
    alignItems: Alignment.center,
    gap: Spacing["500"],
    alignSelf: Alignment.stretch,
    padding: `${Spacing["750"]} ${Spacing["2500"]} ${Spacing["750"]} ${Spacing["1500"]} `,
    backgroundColor,
    color: elementsColor,
    borderTopLeftRadius: Spacing["750"],
    borderBottomLeftRadius: Spacing["750"]
  };
});
export {
  SnackBarContainer
};
//# sourceMappingURL=snackbar-container.es.js.map
